class OkazoNewsletterForms {
  constructor() {
    this.onSubmit = this.onSubmit.bind(this);
    this.onPageShow = this.onPageShow.bind(this);
  }

  init() {
    document.addEventListener("submit", this.onSubmit);
    window.addEventListener("pageshow", this.onPageShow);
    document.querySelector("[data-okz-newsletter-result]")?.focus();
  }

  onSubmit(event) {
    const form = event.target?.closest?.(".okz-newsletter__form");
    if (!form) return;
    if (form.dataset.okazoSubmitting === "true") {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;

    window.setTimeout(() => {
      if (!event.defaultPrevented) this.markSubmitting(form);
    }, 0);
  }

  markSubmitting(form) {
    const button = form.querySelector("[data-okz-newsletter-submit]");
    const label = form.querySelector("[data-okz-newsletter-label]");
    if (!button || !label) return;

    const delay = form.querySelector("[data-okz-newsletter-delay]");
    if (delay) delay.hidden = true;
    form.dataset.okazoSubmitting = "true";
    form.classList.add("is-submitting");
    button.setAttribute("aria-busy", "true");
    button.setAttribute("aria-disabled", "true");
    label.textContent = button.dataset.okzNewsletterLoadingLabel || "Inscription…";

    window.clearTimeout(form.okazoNewsletterResetTimeout);
    form.okazoNewsletterResetTimeout = window.setTimeout(() => {
      this.resetForm(form);
      if (delay) delay.hidden = false;
    }, 12000);
  }

  onPageShow() {
    document.querySelectorAll(".okz-newsletter__form").forEach((form) => this.resetForm(form));
  }

  resetForm(form) {
    const button = form.querySelector("[data-okz-newsletter-submit]");
    const label = form.querySelector("[data-okz-newsletter-label]");

    window.clearTimeout(form.okazoNewsletterResetTimeout);
    delete form.dataset.okazoSubmitting;
    form.classList.remove("is-submitting");
    button?.removeAttribute("aria-busy");
    button?.removeAttribute("aria-disabled");
    const delay = form.querySelector("[data-okz-newsletter-delay]");
    if (delay) delay.hidden = true;
    if (label && button?.dataset.okzNewsletterBaseLabel) {
      label.textContent = button.dataset.okzNewsletterBaseLabel;
    }
  }
}

if (!window.okazoNewsletterForms) {
  window.okazoNewsletterForms = new OkazoNewsletterForms();
  window.okazoNewsletterForms.init();
}
